import React, { Dispatch } from 'react';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { PasslyButton } from '@app/components';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    setIsSuccess: Dispatch<boolean>;
    textSuccess: string;
}

export function MfaTestSuccess({ setIsSuccess, textSuccess }: IProps) {
    const { translation } = useTypedTranslation();

    return (
        <>
            <div className='test-mfa__success--wrapper'>
                <VerifiedUserIcon color='primary' className='test-mfa__success--icon' />

                <h2 className='test-mfa__success--title'>{translation('MFA_VERIFICATION_SUCCESS_HEADER')}</h2>
                <p className='test-mfa__success--text'>{textSuccess}</p>
            </div>
            <PasslyButton onClick={() => setIsSuccess(false)}>
                {translation('TEST_PAGE_MFA_RESET')}
            </PasslyButton>
        </>
    );
}
